import { atom } from 'jotai';

export interface IImagePreviewAtom {
  open: boolean;
  src: string;
  alt?: string;
}

export const imagePreviewAtom = atom<IImagePreviewAtom | null>(null);
